export const system = {
    settings: {
        title: 'Pengaturan',
        general: 'Umum',
        websiteSettings: 'Pengaturan Website',
        siteName: 'Nama Situs',
        logo: 'Logo',
        userManagement: 'Manajemen Pengguna',
        roleManagement: 'Manajemen Role',
        trackingPixels: 'Tracking Pixels',
        customerService: 'Customer Service',
        brands: 'Brand',
        saveSettings: 'Simpan Pengaturan',
        settingsSaved: 'Pengaturan berhasil disimpan!',
    },
    login: {
        title: 'Masuk ke Dashboard',
        email: 'Email',
        password: 'Kata Sandi',
        loginButton: 'Masuk',
        loggingIn: 'Sedang masuk...',
        invalidCredentials: 'Email atau kata sandi salah',
        forgotPassword: 'Lupa Kata Sandi?',
    },
    toast: {
        success: 'Berhasil!',
        error: 'Terjadi kesalahan',
        warning: 'Peringatan',
        info: 'Informasi',
    },
};
